import { Radio } from '@rmwc/radio';
import { useDispatch, useSelector } from "react-redux";
import EditPriceItem from '../../EditPriceItem/EditPriceItem';
import CurrencyFormat from 'react-currency-format';
import { TextField } from '@rmwc/textfield';
import { cetificateChange, getPricingDataForLeanto, pricingLoaderFalse } from '../../../action';
import { useEffect, useState } from 'react';
import { const_var, params } from '../../../redux/reducers/reducer';
import { LEAN_TYPE_NUM_TO_STR } from '../../../Constants/constant';

const Certification = () => {
  const dispatch = useDispatch()
  let certificationItems = []
  let certificate_value = params.p_e_i;
  let certificate_price = const_var.post_data?.building?.certificate_price ? const_var.post_data.building.certificate_price : 0
  const changeCertificate = (value, certificate_value) => {
    if (value != certificate_value) {
      dispatch(cetificateChange(value, "center"))
    }
  }
  return (
    <div className='form-group-lg'>
      <div className="control-label-bar">
        <label className="control-label">Certification</label>
      </div>
      {certificationItems.map(([key, value], index) => {
        return (
          <div className="radio-group" key={key + index}>
            <Radio
              label={key === "Select" ? "Uncertified" : key}
              value={certificate_value}
              checked={certificate_value == value}
              name={certificate_value}
              onClick={() => changeCertificate(value, certificate_value)}
            />
            {certificate_value == value && key !== "Select" && (
              <>
                {const_var.post_data.building !== undefined && const_var.loginSession == true ? (
                  <div className="price-box">
                    <EditPriceItem jsonObj={certificate_price} jsonObjKey="certificate_price" />
                  </div>
                ) : (
                  <div className="price-box-type-2">
                    {const_var.hide_price_calculation != 1 && const_var.loginSession == false && const_var.post_data.building !== undefined && certificate_price !== 0 && (
                      <CurrencyFormat value={certificate_price} displayType={"text"} thousandSeparator={true} prefix={"$"} />
                    )}
                  </div>
                )}
              </>
            )}
          </div>
        );
      }
      )}

      {params.p_e_i === "other" ? null : (
        <div className={params.p_e_i === "other" ? "row mt-2 mb-1" : "d-none"}>
          <div className="col-12 ">
            <div className="more-info-option">
              <label className="control-label" style={{ marginLeft: "2px" }}>
                Name
              </label>
              <div className="floating-label-input">
                <TextField
                  className=""
                  name="p_e_i_other"
                  value={params.p_e_i_other}
                  onChange={(e) => dispatch(cetificateChange(e.target.value, "center", "other"))}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Certification
